import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientService } from '../../../shared/services/http-client/http-client.service';
import {
  CatalogoExtratoQueryParams,
  CondicaoElegibilidadeResponseDto,
  ExtratoDesligamentoResponseDto,
  ExtratoNotificacoesResponseDto,
  SalvarExtratoDesligamentoCommandDto,
  SalvarExtratoNotificacoesCommandDto,
  SituacaoCadastralResponseDto,
} from '../../models/parametros/extrato-desligamento-api.model';

const PLANOS_PARAM_BASE_PATH = '/v1/planos-param';
const SITUACOES_CADASTRAIS_BASE_PATH = '/v1/situacoes-cadastrais';
const CONDICOES_ELEGIBILIDADE_BASE_PATH = '/v1/condicoes-elegibilidade';

@Injectable({
  providedIn: 'root',
})
export class ExtratoDesligamentoApiService {
  constructor(private readonly httpClient: HttpClientService) {}

  obterExtrato(idPlano: number): Observable<ExtratoDesligamentoResponseDto> {
    return this.httpClient.get<ExtratoDesligamentoResponseDto>(this.extratoPath(idPlano));
  }

  /** Substitui a parametrização inteira do plano; devolve o agregado gravado. */
  salvarExtrato(idPlano: number, command: SalvarExtratoDesligamentoCommandDto): Observable<ExtratoDesligamentoResponseDto> {
    return this.httpClient.put<ExtratoDesligamentoResponseDto>(this.extratoPath(idPlano), command);
  }

  obterNotificacoes(idPlano: number): Observable<ExtratoNotificacoesResponseDto> {
    return this.httpClient.get<ExtratoNotificacoesResponseDto>(this.notificacoesPath(idPlano));
  }

  /** Substitui a calendarização do plano (cria o extrato quando falta); devolve o que foi gravado. */
  salvarNotificacoes(
    idPlano: number,
    command: SalvarExtratoNotificacoesCommandDto,
  ): Observable<ExtratoNotificacoesResponseDto> {
    return this.httpClient.put<ExtratoNotificacoesResponseDto>(this.notificacoesPath(idPlano), command);
  }

  listarSituacoesCadastrais(params?: CatalogoExtratoQueryParams): Observable<SituacaoCadastralResponseDto[]> {
    return this.httpClient.get<SituacaoCadastralResponseDto[]>(SITUACOES_CADASTRAIS_BASE_PATH, {
      params: this.toHttpParams(params),
    });
  }

  listarCondicoesElegibilidade(params?: CatalogoExtratoQueryParams): Observable<CondicaoElegibilidadeResponseDto[]> {
    return this.httpClient.get<CondicaoElegibilidadeResponseDto[]>(CONDICOES_ELEGIBILIDADE_BASE_PATH, {
      params: this.toHttpParams(params),
    });
  }

  private extratoPath(idPlano: number): string {
    return `${PLANOS_PARAM_BASE_PATH}/${idPlano}/extrato-desligamento`;
  }

  private notificacoesPath(idPlano: number): string {
    return `${this.extratoPath(idPlano)}/notificacoes`;
  }

  private toHttpParams(params?: CatalogoExtratoQueryParams): HttpParams | undefined {
    if (!params) {
      return undefined;
    }

    let httpParams = new HttpParams();

    for (const [chave, valor] of Object.entries(params)) {
      if (valor != null && valor !== '') {
        httpParams = httpParams.set(chave, String(valor));
      }
    }

    return httpParams.keys().length > 0 ? httpParams : undefined;
  }
}
